import React from "react";
import { graphql, StaticQuery, Link, withPrefix } from "gatsby";
import styles from "./Sidebar.module.scss";

const PureSidebar = ({ data }) => {
  const { author } = data.site.siteMetadata;
  const getMediaHref = (name, contact) => {
    let href;
    switch (name) {
      case "github":
        href = contact;
        break;
      case "email":
        href = `mailto:${contact}`;
        break;
      case "facebook":
        href = contact;
        break;
      case "linkedin":
        href = contact;
        break;
      default:
        href = contact;
        break;
    }
    return href;
  };
  const ICONS = {
    FACEBOOK: {
      path:
        "M14.984 0.187v4.125h-2.453c-1.922 0-2.281 0.922-2.281 2.25v2.953h4.578l-0.609 4.625h-3.969v11.859h-4.781v-11.859h-3.984v-4.625h3.984v-3.406c0-3.953 2.422-6.109 5.953-6.109 1.687 0 3.141 0.125 3.563 0.187z",
      viewBox: "0 0 16 28"
    },
    GITHUB: {
      path:
        "M10 19c0 1.141-0.594 3-2 3s-2-1.859-2-3 0.594-3 2-3 2 1.859 2 3zM20 19c0 1.141-0.594 3-2 3s-2-1.859-2-3 0.594-3 2-3 2 1.859 2 3zM22.5 19c0-2.391-1.453-4.5-4-4.5-1.031 0-2.016 0.187-3.047 0.328-0.812 0.125-1.625 0.172-2.453 0.172s-1.641-0.047-2.453-0.172c-1.016-0.141-2.016-0.328-3.047-0.328-2.547 0-4 2.109-4 4.5 0 4.781 4.375 5.516 8.188 5.516h2.625c3.813 0 8.188-0.734 8.188-5.516zM26 16.25c0 1.734-0.172 3.578-0.953 5.172-2.063 4.172-7.734 4.578-11.797 4.578-4.125 0-10.141-0.359-12.281-4.578-0.797-1.578-0.969-3.437-0.969-5.172 0-2.281 0.625-4.438 2.125-6.188-0.281-0.859-0.422-1.766-0.422-2.656 0-1.172 0.266-2.344 0.797-3.406 2.469 0 4.047 1.078 5.922 2.547 1.578-0.375 3.203-0.547 4.828-0.547 1.469 0 2.953 0.156 4.375 0.5 1.859-1.453 3.437-2.5 5.875-2.5 0.531 1.062 0.797 2.234 0.797 3.406 0 0.891-0.141 1.781-0.422 2.625 1.5 1.766 2.125 3.938 2.125 6.219z",
      viewBox: "0 0 26 28"
    },
    EMAIL: {
      path:
        "M26 23.5v-12c-0.328 0.375-0.688 0.719-1.078 1.031-2.234 1.719-4.484 3.469-6.656 5.281-1.172 0.984-2.625 2.188-4.25 2.188h-0.031c-1.625 0-3.078-1.203-4.25-2.188-2.172-1.813-4.422-3.563-6.656-5.281-0.391-0.313-0.75-0.656-1.078-1.031v12c0 0.266 0.234 0.5 0.5 0.5h23c0.266 0 0.5-0.234 0.5-0.5zM26 7.078c0-0.391 0.094-1.078-0.5-1.078h-23c-0.266 0-0.5 0.234-0.5 0.5 0 1.781 0.891 3.328 2.297 4.438 2.094 1.641 4.188 3.297 6.266 4.953 0.828 0.672 2.328 2.109 3.422 2.109h0.031c1.094 0 2.594-1.437 3.422-2.109 2.078-1.656 4.172-3.313 6.266-4.953 1.016-0.797 2.297-2.531 2.297-3.859zM28 6.5v17c0 1.375-1.125 2.5-2.5 2.5h-23c-1.375 0-2.5-1.125-2.5-2.5v-17c0-1.375 1.125-2.5 2.5-2.5h23c1.375 0 2.5 1.125 2.5 2.5z",
      viewBox: "0 0 28 28"
    },
    LINKEDIN: {
      path:
        "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z",
      viewBox: "0 0 24 24"
    }
  };
  const getIcon = name => {
    let icon;

    switch (name) {
      case "github":
        icon = ICONS.GITHUB;
        break;
      case "facebook":
        icon = ICONS.FACEBOOK;
        break;
      case "linkedin":
        icon = ICONS.LINKEDIN;
        break;
      case "email":
        icon = ICONS.EMAIL;
        break;
      default:
        icon = {};
        break;
    }
    return icon;
  };

  const Icon = ({ icon }) => (
    <svg className={styles.icon} viewBox={icon.viewBox}>
      <path d={icon.path} />
    </svg>
  );

  return (
    <div className={styles.sidebar}>
      <div className={styles.author}>
        <Link to="/">
          <img
            className={styles.author__photo}
            src={withPrefix(author.photo)}
            alt={author.name}
          />
        </Link>
        <h1 className={styles.author__name}>
          <Link to="/">{author.name}</Link>
        </h1>
        <p>{author.bio}</p>
      </div>
      <nav className={styles.navbar}>
        <ul className={styles.navbar__list}>
          <li>
            <Link
              to="/"
              className={styles.navbar__link}
              activeClassName={styles.active}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/projects"
              className={styles.navbar__link}
              activeClassName={styles.active}
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={styles.navbar__link}
              activeClassName={styles.active}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
      <div className={styles.media}>
        <ul className={styles.list__links}>
          {Object.keys(author.contacts).map(name => (
            <li key={name} className={styles.list__links__item}>
              <a
                href={getMediaHref(name, author.contacts[name])}
                rel={name === "email" ? "" : "noopener noreferrer"}
                target={name === "email" ? "" : "_blank"}
                aria-label={name}
              >
                <Icon icon={getIcon(name)} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Sidebar = props => (
  <StaticQuery
    query={graphql`
      query SidebarQuery {
        site {
          siteMetadata {
            title
            copyright
            author {
              name
              bio
              photo
              contacts {
                facebook
                github
                email
                linkedin
              }
            }
          }
        }
      }
    `}
    render={data => <PureSidebar {...props} data={data} />}
  />
);

export default Sidebar;
